// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-field {
  margin-bottom: var(--ce-base-padding-small)
}
`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Join.css"],"names":[],"mappings":"AAAA;EACE;AACF","sourcesContent":[".login-field {\n  margin-bottom: var(--ce-base-padding-small)\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
